export class Fase {
  id;
  titolo;
  tipologia;
  dataInizio;
  dataFineCensimento;
  dataFine;

  bando;
  bando_id;

  raccoltaDomande;
  fasiAssociate;

  constructor(id, titolo, bando, bando_id, tipologia, raccoltaDomande, fasiAssociate) {
    this.id = id;
    this.titolo = titolo;
    this.bando = bando;
    this.bando_id = bando_id;
    this.tipologia = tipologia;
    this.raccoltaDomande = raccoltaDomande ?? null;
    this.fasiAssociate = fasiAssociate ?? [];
  }
}
